import { useEffect } from 'react'

import { createFileRoute } from '@tanstack/react-router'
import { createStore, Provider } from 'jotai'
import { match } from 'ts-pattern'

import RecapShapeKepPage from '@/components/pages/guest/_recap-shape-kep/containers/recap-shape-kep-page'
import { useFilters } from '@/components/pages/guest/_recap-shape-kep/state/filters-atom'
import { searchParamsSchema } from '@/components/pages/guest/_recap-shape-kep/types'

const store = createStore()

export const Route = createFileRoute('/_guest/guest/recap-shape-kep')({
  component: () => (
    <Provider store={store}>
      <RouteComponent />
    </Provider>
  ),
  validateSearch: searchParamsSchema
})

function RouteComponent() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()
  const filters = useFilters()

  useEffect(() => {
    if (search.province_code) {
      filters.onProvinceChange(search.province_code, false)
    }
    if (search.city_code) {
      filters.onCityChange(search.city_code, false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search.province_code, search.city_code])

  return (
    <RecapShapeKepPage
      activeTab={search.tab}
      onTabChange={tab => {
        const onChange = match(tab)
          .with('national', () => filters.reset)
          .with('province', () => filters.onProvinceChange)
          .with('city', () => filters.onCityChange)
          .exhaustive()

        const code = match(tab)
          .with('province', () => search.province_code ?? '')
          .with('city', () => search.city_code ?? '')
          .otherwise(() => '')

        onChange(code)
        navigate({ search: { ...search, tab } })
      }}
    />
  )
}
